export const MULTIPLE_CONTENTS_CONFIG = 'row_content_viewer_list';
export const SINGLE_CONTENT_CONFIG = 'content_viewer';
export const CONTENTS_QUERY_CONFIG = 'content_viewer_list';
